import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-attendance-count-card',
  templateUrl: './attendance-count-card.component.html',
  styleUrls: ['./attendance-count-card.component.scss']
})
export class AttendanceCountCardComponent {
  @Input() title: string = ''; // Title of the card
  @Input() totalCount: number = 0; // Total count value
  @Input() progressBarPercentage: number = 0; // Progress bar value
  @Input() activeLabel: string = 'Active'; // Label for the active data
  @Input() activeCount: number = 0; // Count for the active data
  @Input() activeColor: string = '#ACF3AA'; // Color for the active indicator
  @Input() upcomingLabel: string = 'Upcoming'; // Label for the upcoming data
  @Input() upcomingCount: number = 0; // Count for the upcoming data
  @Input() upcomingColor: string = '#F38D8D'; // Color for the upcoming indicator
  @Input() showSignedOut: boolean = false;
  @Input() showNotMarked: boolean = false;
  @Input() signedOutLabel: string = 'Signed-out'; // Label for the signed-out data
  @Input() signedOutCount: number = 0; // Count for the signed-out data
  @Input() signedOutColor: string = '#FCCF7A'; // Color for the signed-out indicator
  @Input() notMarkedLabel: string = 'Not Marked'; // Label for the not marked data
  @Input() notMarkedCount: number = 0; // Count for the not marked data
  @Input() notMarkedColor: string = '#7ADCFC'; // Color for the not marked indicator
  @Input() remainingColor: string = '#E0E0E0';
  @Input() selectedFilter: string | null = null; // Selected filter for highlighting
  @Output() filterClick = new EventEmitter<any>();

  get activeProgressPercentage(): number {
    return this.totalCount > 0 ? this.calculateProgressPercentage(this.activeCount, this.totalCount) : 0;
  }

  get upcomingProgressPercentage(): number {
    return this.totalCount > 0 ? this.calculateProgressPercentage(this.upcomingCount, this.totalCount) : 0;
  }
  get signedOutProgressPercentage(): number {
    //if (!this.showSignedOut) return 0;
    return this.totalCount > 0 ? this.calculateProgressPercentage(this.signedOutCount, this.totalCount) : 0;
  }

  get notMarkedProgressPercentage(): number {
    //if (!this.showNotMarked) return 0;
    return this.totalCount > 0 ? this.calculateProgressPercentage(this.notMarkedCount, this.totalCount) : 0;
  }

  get remainingProgressPercentage(): number {
    if (this.totalCount === 0) {
      return 100; // Default to 100% gray when there are no students
    }
    const allocatedCount = (this.activeCount || 0) + (this.upcomingCount || 0) + (this.signedOutCount || 0) + (this.notMarkedCount || 0);
    const remainingCount = Math.max(0, this.totalCount - allocatedCount);
    return this.calculateProgressPercentage(remainingCount, this.totalCount);
  }

  private calculateProgressPercentage(part: number, total: number): number {
    return total ? (part / total) * 100 : 0;
  }

  onFilterClick(filterName: string, filterType: string) {
    this.filterClick.emit({
      filterName: filterName,
      filterType: filterType
    });
  }
}
